import { render, staticRenderFns } from "./GoogleMyBusiness.vue?vue&type=template&id=06c34f3a&scoped=true&"
import script from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMyBusiness.vue?vue&type=style&index=0&id=06c34f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c34f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VExpansionPanels,VIcon,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems})
